import { render, staticRenderFns } from "./register-review-completion-stage.vue?vue&type=template&id=49c1557a&lang=pug&"
import script from "./register-review-completion-stage.vue?vue&type=script&lang=ts&"
export * from "./register-review-completion-stage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports